// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7cd98620","455":"821759cc","977":"58f7a4bd"}[chunkId] + ".chunk.js";
};